<template>
  <price :value="price" class="success--text"></price>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Purchase from '@/api/purchase'
  import { Price } from '@/components/formatters'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      Price
    },
    mixins: [purchase],
    computed: {
      ...mapGetters({
        currentUser: 'skiliko/session/currentUser'
      }),
      price () { return Purchase.creditedPrice(this.purchase, this.currentUser) }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/ReceivedPrice.vue